<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-3"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-form ref="form">
        <v-container>
          <v-card
            class="mx-auto justify-center mb-6"
            :max-width="(isMobile ? 380 : 500)"
            :class="{'pa-6': !isMobile}"
            style="border-radius: 10px"
            :elevation="(isMobile ? 0 : 10)"
            :flat="isMobile"
          >
            <v-row :class="{'mx-0' : !isMobile}">
              <v-card-title
                class="justify-start mt-4"
                :style="{'margin-top':(isMobile ? '40px !important' : '0px')}"
                grey
                style="width: 100%"
                darken-3
              >
                <h2>{{ $t('reset password') }}</h2>
              </v-card-title>
              <v-col
                v-if="!chenged"
                cols="12"
                class="mb-3"
              >
                <v-text-field
                  v-model="password"
                  :label="$t('password')"
                  :rules="rules"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  dense
                  height="36"
                  outlined
                  clearable
                  @click:append="show = !show"
                />
              </v-col>
              <v-col
                v-if="!chenged"
                cols="12"
                class="mb-3"
              >
                <v-text-field
                  v-model="repeatPassword"
                  :label="$t('repeat password')"
                  :rules="repeatRules"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  dense
                  height="36"
                  outlined
                  clearable
                  @click:append="show = !show"
                />
              </v-col>
              <v-col
                class="xs py-0"
                style="display: flex"
                cols="12"
                md="12"
                sm="12"
              >
                <v-chip
                  v-if="!error && password && repeatPassword"
                  label
                  outlined
                  color="pink"
                  style="width: 100%"
                >
                  {{ $t('The password does not equal the repetition') }}
                </v-chip>
                <v-chip
                  v-if="chenged"
                  label
                  outlined
                  color="green"
                  style="width: 100%"
                >
                  {{ $t('Your password changed') }}
                </v-chip>
              </v-col>
              <v-col
                cols="12"
              >
                <v-btn
                  v-if="chenged"
                  :loading="loading"
                  block
                  color="pOrrange mr-0"
                  @click="goTo('login')"
                >
                  {{ $t('Login') }}
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="!chenged"
                  v-shortkey="['enter']"
                  :loading="loading"
                  block
                  color="primary mr-0"
                  @shortkey="submit"
                  @click="submit"
                  :disabled="!error"
                >
                  {{ $t('submit') }}
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" />
            </v-row>
          </v-card>
        </v-container>
      </v-form>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;"
      padless
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import Language from '../../components/core/LanguageBar'
  export default {
    components: {
      Language,
      Snakbar,
    },
    mixins: [General],
    props: ['phoneProp', 'tokenProp'],
    data () {
      return {
        phone: null,
        lang: null,
        token: null,
        chenged: false,
        rules: null,
        repeatRules: null,
        dateFormat: 'fa,en',
        dateFormatLang: 'YYYY/MM/DD',
        show: null,
        password: null,
        repeatPassword: null,
        has_error: false,
        text_error: null,
        loading: false,
      }
    },
    computed: {
      error: function () {
        if (this.password !== this.repeatPassword) {
          return false
        } else {
          return true
        }
      },
    },
    watch: {
      error () {
      },
    },
    beforeMount () {
      this.rules = [
        v => !!v || this.$t('is-required'),
      ]
      this.repeatRules = [
        v => !!v || this.$t('is-required'),
      ]
      if (!this.phoneProp && !this.tokenProp) {
        this.goTo('forgetPassword')
      }
      this.phone = this.phoneProp
      this.token = this.tokenProp
      this.plan = this.planProp
    },
    mounted () {
      if (localStorage.getItem('lang')) {
        this.$refs.refLang.changeLanguage(JSON.parse(localStorage.getItem('lang')))
      }
    },
    methods: {
      submit () {
        var app = this
        app.loading = true
        app.$axios.post(this.$apipoint + 'forgetPassword', app.$data)
          .then(res => {
            this.chenged = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.loading = false))
      },
      editEmail () {
        this.goTo('register')
      },
    },

  }
</script>

<style scoped>

</style>
